import { type SerializedCompStructure } from '@wix/document-services-types'

import { type TextInputData } from '../types'

export function assertTextInputData(
  data: NonNullable<SerializedCompStructure['data']>,
): asserts data is TextInputData {
  const TYPE: TextInputData['type'] = 'TextInput'
  if (data.type !== TYPE) {
    throw new Error('Not text-input data.')
  }
}
